import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './services/userKeyService';

// Index.tsx loaded

// Register service worker for PWA functionality (only in production)
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
          
          // Check for updates every 60 seconds
          setInterval(() => {
            registration.update();
          }, 60000);
          
          // Listen for service worker updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New service worker installed - show update notification
                  const updateBanner = document.createElement('div');
                  updateBanner.style.cssText = `
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    background: #4CAF50;
                    color: white;
                    padding: 16px;
                    text-align: center;
                    z-index: 10000;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
                    font-family: Arial, sans-serif;
                  `;
                  
                  const reloadButton = document.createElement('button');
                  reloadButton.textContent = 'Reload Now';
                  reloadButton.style.cssText = `
                    margin-left: 20px;
                    background: white;
                    color: #4CAF50;
                    border: none;
                    padding: 8px 20px;
                    border-radius: 4px;
                    font-weight: 600;
                    cursor: pointer;
                  `;
                  reloadButton.addEventListener('click', async () => {
                    // Show feedback to user
                    reloadButton.textContent = 'Updating...';
                    reloadButton.disabled = true;
                    reloadButton.style.opacity = '0.6';
                    reloadButton.style.cursor = 'not-allowed';
                    
                    try {
                      // Unregister the old service worker with 5-second timeout
                      const unregisterPromise = registration.unregister();
                      const timeoutPromise = new Promise(resolve => setTimeout(resolve, 5000));
                      
                      await Promise.race([unregisterPromise, timeoutPromise]);
                      console.log('Service worker unregistered successfully');
                      
                    } catch (error) {
                      console.error('SW unregister error (will reload anyway):', error);
                    }
                    
                    // Always reload with cache-busting, regardless of success/failure
                    const url = new URL(window.location.href);
                    url.searchParams.set('v', Date.now().toString());
                    window.location.href = url.toString();
                  });
                  
                  updateBanner.innerHTML = '<strong>🎉 A new version is available!</strong>';
                  updateBanner.appendChild(reloadButton);
                  document.body.appendChild(updateBanner);
                }
              });
            }
          });
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  } else {
    // Unregister service worker in development to prevent caching issues
    window.addEventListener('load', () => {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
          registration.unregister();
          console.log('SW unregistered for development');
        }
      });
    });
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
